export default "__VITE_ASSET__8a21756e__"